/* global System */

export default {
  DecisionTree: () => System.import('./Component'),
}
